export default __webpack_public_path__ + "static/media/customization_1.e31a940a.webp";